// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.data-view.constructor');



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/core-js/modules/es.data-view.js
// module id = 469
// module chunks = 0